<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h1>Platform / Datepicker</h1>
  </div>
</div>

<div class="row">
  <div class="col-12 col-sm-6">
    <h3>Date - single</h3>
    <div class="button-row">
      <ui-platform-datepicker></ui-platform-datepicker>
    </div>
  </div>
</div>
